module.exports = __webpack_public_path__ + "img/DSC_0051-compressor.1b7224c4.jpg";